import { useSelector } from "react-redux";

import HomeMention from "./HomeMention";

const HomeChemist = ({ nowList, readyList }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const mention = reduxChannel?.mention_content
		? reduxChannel?.mention_content?.split("<b>")
		: ["", ""];
	if (reduxChannel?.mention_content) {
		return (
			<div
				style={{
					// backgroundColor: "#eaeff6",
					backgroundColor: "#e5f0ff",
				}}
			>
				{!(!!nowList?.length || !!readyList?.length) && (
					<div
						className={`home-each home-header`}
						id={`home-mobile`}
						style={{
							// backgroundColor: "#eaeff6",
							backgroundColor: "#e5f0ff",
							paddingBottom: 0,
							// marginBottom: "4em",
						}}
					>
						<div className={`max-width-apply`}>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
								}}
							>
								<p className={`sub-pre-title`}>{mention[0]}</p>
								<h3
									className={`each-title`}
									style={{ width: "fit-content", textAlign: "center" }}
								>
									{/*약국에서 근무하는 약사로서 상담을 좋아하는 {reduxChannel?.nickname}*/}
									{mention[1] ? mention[1] : reduxChannel.nickname}
								</h3>
								<img
									// src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}_mention.${reduxChannel?.mention_img_type}`}
									src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}_mention.${reduxChannel?.mention_img_type}`}
									// src={`/assets/images/channel/doctor.png`}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null; // prevents looping
										// currentTarget.style.display = "none";
										currentTarget.src = `/assets/images/channel/basic.png`;
									}}
									alt={`채널 이미지`}
									style={{
										width: "100%",
										height: "auto",
										marginTop: "1.5em",
										maxWidth: "28em",
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{/*{!(!!nowList?.length || !!readyList?.length) && (*/}
				{/*<div*/}
				{/*    className={`home-each home-header`}*/}
				{/*    id={`home-mobile`}*/}
				{/*    style={{*/}
				{/*        padding: "0 10em",*/}
				{/*        // marginTop: "-10em"*/}
				{/*    }}*/}
				{/*>*/}
				{/*    <div className={`max-width-apply`}>*/}
				{/*        <GroupBuyingEvent/>*/}
				{/*    </div>*/}
				{/*</div>*/}
				{/*)}*/}

				<HomeMention />
			</div>
		);
	} else return <></>;
};
export default HomeChemist;
